import swal from 'sweetalert2';
import { publicRoutesPath } from '../Routes';
import history from './history';
import { store } from '../index';
import { requestLogout } from '../Store/User/action';

let isDialogOpen = false;

export const sessionExpiredDialog = () => {
    if (isDialogOpen) return;
    isDialogOpen = true;

    // Dispatch requestLogout first — this atomically:
    //   1. Removes accessToken from localStorage
    //   2. Dispatches LOGOUT which resets Redux (currentUser, rolebasedData, isFetchingUser) to initial state
    // This causes PublicRoute to re-render and unmount BiztantuLoader before the dialog shows.
    store.dispatch(requestLogout());

    return new swal({
        width: 350,
        padding: 10,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        confirmButtonColor: 'black',
        text: 'Current session is expired. ',
        type: 'warning',
        confirmButtonText: 'Login',
    }).then(function() {
        isDialogOpen = false;
        history.push(publicRoutesPath.LOGIN);
    }).catch(function() {
        isDialogOpen = false;
    });
}